import { UserDocument } from "../../../coreIdAPI";

let getWholeName = (userDocument: UserDocument) => {
  return `${userDocument.firstName || ""} ${userDocument.middleName || ""} ${
    userDocument.lastName || ""
  } ${userDocument.secondLastName || ""}`;
};

export { getWholeName };
